---
en:
  power_plant_responsible:
    delete_confirm_text: Are you sure you want to remove this responsible from the power plant? This action cannot be undone.
    delete_confirm_title: Remove Power Plant Responsible
  responsible:
    add: Add responsible
    already_linked_description: This responsible is already linked to a user account. You can update the name and phone, but cannot unlink from the user.
    already_linked_title: Already Linked to User
    auto_switched_description: We automatically switched to "Link to user" mode because this email matches an existing user account.
    create_mode_description: You are creating a new responsible person. Fill in the form below and save to create the new person.
    create_mode_title: Create New Responsible
    create_new: Create new
    delete_confirm_text: Are you sure you want to delete this responsible? This action cannot be undone.
    delete_confirm_title: Delete Responsible
    deleted_completely: "%{name} has been completely removed from the system."
    deleted_preserved: "%{name} has been removed from this company but kept in the system due to other connections (notifications, work items, etc.)."
    edit: Edit responsible
    edit_mode_description: You are now editing responsible person details. Fill in the form below and save to update the information.
    edit_mode_title: Edit Mode Active
    edit_plural: Edit responsibles
    edit_power_plant_responsible: Edit power plant responsible for
    edit_tooltip: Edit or create new responsible person
    email_from_linked_user: Email from linked user account
    email_match_detected_title: Email Match Detected
    link_to_user: Link to user
    linked_to_user: Linked to user
    matched_user: 'Matched user:'
    must_have_name_email: Responsible must have either name or email
    phone_change_warning_description: Changing this phone number will update it for the linked user account everywhere in the system.
    phone_change_warning_title: User Phone Update Warning
    phone_from_matched_user: Phone number from matched user account
    responsible: Responsible
    responsibles: Responsibles
    role: Role
    save_and_link: Save & Link to User
    select_responsible: Select responsible person
    task_responsible: Task management access
